import { createAction, props } from '@ngrx/store';
import {
  BalancesOverviewResponse,
  ContactPayload,
  RecentTransactionsResponse,
  SearchedContact,
} from '../state/dashboard.state';

export const getSearchContacts = createAction(
  '[Dashboard] SEARCH_CONTACTS',
  props<{ searchedContact: string }>(),
);

export const getSearchContactsSuccess = createAction(
  '[Dashboard] SEARCH_CONTACTS_SUCCESS',
  props<{ searchedContacts: SearchedContact[] }>(),
);

export const getSearchContactsError = createAction(
  '[Dashboard] SEARCH_CONTACTS_ERROR',
);

export const resetSearchedContacts = createAction(
  '[Dashboard] RESET_SEARCH_CONTACTS',
);

export const addChosenContact = createAction(
  '[Dashboard] ADD_CHOSEN_CONTACT',
  props<{ payload: ContactPayload }>(),
);

export const addChosenContactSuccess = createAction(
  '[Dashboard] ADD_CHOSEN_CONTACT_SUCCESS',
);

export const addChosenContactError = createAction(
  '[Dashboard] ADD_CHOSEN_CONTACT_ERROR',
);

export const inviteChosenContact = createAction(
  '[Dashboard] INVITE_CHOSEN_CONTACT',
);

export const getBalancesOverview = createAction(
  '[Dashboard] GET_BALANCES_OVERVIEW',
);

export const getBalancesOverviewSuccess = createAction(
  '[Dashboard] GET_BALANCES_OVERVIEW_SUCCESS',
  props<{ balancesOverview: BalancesOverviewResponse }>(),
);

export const getBalancesOverviewError = createAction(
  '[Dashboard] GET_BALANCES_OVERVIEW_ERROR',
);

export const getRecentTransactions = createAction(
  '[Dashboard] GET_RECENT_TRANSACTIONS',
  props<{ selectedYear: number }>(),
);

export const getRecentTransactionsSuccess = createAction(
  '[Dashboard] GET_RECENT_TRANSACTIONS_SUCCESS',
  props<{ response: RecentTransactionsResponse }>(),
);

export const getRecentTransactionsError = createAction(
  '[Dashboard] GET_RECENT_TRANSACTIONS_ERROR',
);

export const inviteChosenContactSuccess = createAction(
  '[Dashboard] INVITE_CHOSEN_CONTACT_SUCCESS',
);

export const inviteChosenContactError = createAction(
  '[Dashboard] INVITE_CHOSEN_CONTACT_ERROR',
);
